import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AlertModule } from 'ngx-bootstrap/alert';
import { NgxUploaderModule } from 'ngx-uploader';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { MomentModule } from 'ngx-moment';
import { NgxPaginationModule } from 'ngx-pagination';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  exports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    RouterModule,
    ModalModule,
    AlertModule,
    NgxUploaderModule,
    SelectDropDownModule,
    NgxPaginationModule,
    MomentModule,
    BsDropdownModule
  ],
})
export class SharedModule {}
